export type Municipality = {
    label: string;
    value: string;
};

export type HubspotSubscription = {
    subscription_id: string;
    subscription_status: string;
};

export type HubspotSubscriptionDefinition = {
    subscription_id: string;
    name_sv: string;
    description: string;
    name: string;
    isActive:boolean;
};

export type EmailSettingsSaveResult =
    | { type: 'hubspot'; ok: boolean; error?: unknown }
    | { type: 'dfr'; ok: boolean; error?: unknown };

export type HubspotApiResponse = {
    hubspot_subscriptions?: HubspotSubscription[];
    hubspot_user_subscriptions?: HubspotSubscription[];
    hubspot_subscription_definitions?: HubspotSubscriptionDefinition[];
};

export type HubspotData = {
    hubspot_user_subscriptions?: HubspotSubscription[];
    hubspot_subscription_definitions?: HubspotSubscriptionDefinition[];
};

export type UserSettingsContextValue = {
    userData: { [key: string]: unknown };
    hubspotData: HubspotData;
    requiredFields: unknown;
    munis: Municipality[] | undefined;
    refetchUserData: () => void;
    refetchHubspotData: () => void;
};

export type PlusSubscription = {
    id: number;
    designation: string;
    ref: string;
    start_time: string;
    end_time: string;
    auto_renew: boolean;
};


export function isPlusSubscription(subscription: unknown): subscription is PlusSubscription {
    if (!subscription || typeof subscription !== 'object') {
      return false;
    }
  
    const id = Reflect.get(subscription, 'id');
    const designation = Reflect.get(subscription, 'designation');
    const ref = Reflect.get(subscription, 'ref');
    const startTime = Reflect.get(subscription, 'start_time');
    const endTime = Reflect.get(subscription, 'end_time');
    const autoRenew = Reflect.get(subscription, 'auto_renew');
  
    return (
      typeof id === 'number' &&
      typeof designation === 'string' &&
      typeof ref === 'string' &&
      typeof startTime === 'string' &&
      typeof endTime === 'string' &&
      typeof autoRenew === 'boolean'
    );
  }
